// Module
var code = `<template>
  <require from="./unconverted-instruments-widget.scss"></require>

  <!-- beautify ignore:start -->
  <style>
    .unconverted-instruments-widget-\${id} {
      font-family: \${font};
      font-size: \${fontSize}px;
    }

    .unconverted-instruments-widget-\${id} a {
      color: \${color | widgetTemplateColor:isInDashboard} !important;
    }
  </style>
  <!-- beautify ignore:end -->

  <div class="unconverted-instruments-widget unconverted-instruments-widget-\${id}">
    <a route-href="route: unconverted">\${data.length}</a>
  </div>
</template>
`;
// Exports
export default code;